<template>
  <div class="messagePage">
    <div class="messageContainer">
      <div class="tabList">
        <div
          class="tab pointer"
          :class="{'tabSelected': tabSelected === key}"
          v-for="(key, index) in tabList"
          :key="index"
          @click="selectTab(key)">
          {{tabCase(key)}}
          <div class="unreadNum" v-if="unreadNum[key]">
            {{unreadNum[key]}}
          </div>
        </div>
      </div>
      <div class="messageContent"
           v-infinite-scroll="fetchMessage"
           :infinite-scroll-disabled="hasLoadAll"
           v-if="messageList.length"
      >
        <div
          class="messageItem pointer"
          :class="{'messageRead': item.Status===MessageStatus.Read}"
          v-for="(item, index) in messageList"
          :key="index"
          @click="handelShowDetail(item, index)">
          <div class="time">{{formatTime(item.CreatedAt)}}</div>
          <div class="message">
            <!--              <div class="name">qwerty</div>-->
            <div class="subject">{{item.Subject}}</div>
          </div>
        </div>
        <div class="bottomLogo" v-if="hasLoadAll && messageList.length">
          <img :src="logo" alt="">
        </div>
      </div>
      <div class="empty" v-if="!messageList.length && skipNum">
        - -
      </div>
    </div>
    <MessageDetail :detail="detail" v-if="showDetail"/>
  </div>
</template>

<script>
import MessageDetail from './Children/messageDetail'
import {MessageStatus, MessageCategory} from '@/constant'
import request from '@/service'
import logo from '@/assets/images/common/logo1.svg'
export default {
  name: 'Message',
  data () {
    return {
      MessageStatus,
      logo,
      tabList: [
        this.$t('lang.setting.system'),
        this.$t('lang.setting.event'),
        this.$t('lang.setting.personal')
      ],
      tabSelected: this.$t('lang.setting.system'),
      messageList: [],
      unreadNum: {
        System: 0,
        Event: 0,
        Personal: 0
      },
      skipNum: 0,
      takeNum: 20,
      hasLoadAll: false,
      showDetail: false,
      detail: {}
    }
  },
  computed: {
    tabCase () {
      return (key) => {
        return this.tabSelected === key ? key.toUpperCase() : key
      }
    },
    formatTime () {
      return (timeStr) => {
        const date = timeStr.split('T')[0]
        const time = timeStr.split('T')[1].split(':')
        return date + ' ' + time[0] + ':' + time[1]
      }
    }
  },
  components: {
    MessageDetail
  },
  mounted () {
    this.fetchMessage()
    this.fetchUnreadCount()
  },
  methods: {
    selectTab (key) {
      this.tabSelected = key
      this.messageList = []
      this.skipNum = 0
      this.fetchMessage()
    },
    fetchMessage () {
      const url = '/innovation/message/getmessages'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        skip: this.skipNum,
        take: this.takeNum,
        category: MessageCategory[this.tabSelected] // status filter. 0: Undefined(all), 1: NotRead, 2: Read
      }
      request('post', url, data).then(res => {
        // this.fetchUnreadCount()
        console.log(res)
        this.messageList = this.messageList.concat(res.UserMessageDetails)
        this.skipNum += this.takeNum
        this.hasLoadAll = this.skipNum >= res.Total
      })
    },
    handelShowDetail (detail, index) {
      if (this.unreadNum[this.tabSelected] > 0 && this.messageList[index].Status === MessageStatus.Unread) {
        this.unreadNum[this.tabSelected]--
      }
      this.messageList[index].Status = MessageStatus.Read
      this.detail = detail
      this.detail.time = this.formatTime(detail.CreatedAt)
      this.showDetail = true
      const url = '/innovation/message/markread'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        messageId: detail.Id
      }
      request('post', url, data, true)
    },
    fetchUnreadCount () {
      const url = '/innovation/message/getnotreadmessagescount'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data).then(res => {
        console.log(res)
        res.NotReadMessagesCount.forEach(item => {
          Object.keys(MessageCategory).forEach(key => {
            if (MessageCategory[key] === item.Category) this.unreadNum[key] = item.Count
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    closeDetail () {
      this.showDetail = false
    }
  }
}
</script>

<style lang="less" scoped>
  .messagePage {
    height: 100%;
    .messageContainer {
      height: 100%;
      .tabList {
        display: flex;
        width: 50%;
        text-align: center;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        .tab {
          flex: 1;
          position: relative;
          font-size: 16px;
          color: #686868;
        }
        .tabSelected {
          font-family: Roboto-Medium, sans-serif;
          color: #F6D9AA;
          line-height: 21px;
          font-weight: 500;
        }
        .unreadNum {
          position: absolute;
          top: -15px;
          left: calc(50% + 40px);
          transform: translateX(-50%);
          padding: 0 4px;
          font-size: 10px;
          line-height: 15px;
          color: #fff;
          background-color: #ff0000;
          border-radius: 30px;
        }
      }
      .messageContent {
        height: 456px;
        overflow: auto;
        padding-right: 10px;
        padding-top: 5px;
        .messageItem {
          padding: 14px 15px 20px;
          color: #fff;
          background: #3D3D3D;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
          border-radius: 6px;
          margin-bottom: 20px;
          .time {
            font-size: 12px;
            line-height: 14px;
            margin-bottom: 9px;
          }
          .message {
            display: flex;
            justify-content: space-between;
            align-items: center;
            div {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 18px;
              line-height: 21px;
            }
            .subject {
              flex: 1;
              color: #F6D9AA;
              font-weight: bold;
            }
            /*.name {
              flex: 1;
              color: #F6D9AA;
              font-weight: bold;
            }
            .subject {
              flex: 2;
              text-align: right;
            }*/
          }
        }
        .messageRead {
          background-color: #272727!important;
          div {
            color: #686868!important;
          }
        }
        .bottomLogo {
          text-align: right;
          img {
            width: 40px;
          }
        }
        &::-webkit-scrollbar {
          width: 1px;
          height: 100%;
        }
        &::-webkit-scrollbar-track {
          width: 1px;
          height: 100%;
          background-color: transparent;
          border-radius: 33px;
        } /* 滚动条的滑轨背景颜色 */
        &::-webkit-scrollbar-thumb {
          width: 1px;
          border-radius: 33px;
          background-color: #F6D9AA;
        } /* 滑块颜色 */
      }
      .empty {
        padding: 20px;
        color: #686868;
        text-align: center;
        background: #272727;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
        border-radius: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Message/index.vue